import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProxyTypePipe } from './proxyType.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [ProxyTypePipe],
    providers: [ProxyTypePipe],
    exports: [ProxyTypePipe],
})
export class ProxyTypePipeModule {}
